<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="assessment-view-page-title" class="mb-3">
              {{ assessment.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('assessment_template')">
                <GuideButton :guide="getGuide('assessment_template')"></GuideButton>
              </span>
            </div>
            <span v-if="assessment.type" class="mr-2">
              {{ $t('projects.table.type') }}:
            </span>
            <span v-if="assessment.type" class="mr-1">
              {{ $t('maintenance.assessments.type.' + $options.filters.slugify(assessment.type)) }}
            </span>
            <span v-if="assessment.scope && (assessment.type == 'risk' || assessment.type == 'bia')" class="mr-2 ml-2">
              {{ $t('projects.table.scope') }}:
            </span>
            <span v-if="assessment.scope && (assessment.type == 'risk' || assessment.type == 'bia')" class="badge mr-1">
              <font-awesome-icon icon="crosshairs"/>
              {{ $t('projects.scope.' + $options.filters.slugify(assessment.scope)) }}
            </span>
          </div>

          <div class="col-md-6 text-right" qid="view-a-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                      class="btn btn-edit"
                      qid="edit-a-button"
                      @click="showEditAModal(assessment)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.ASSESSMENT_DELETE, permissions.ASSESSMENT_DELETE_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                      class="btn btn-delete"
                      qid="delete-a-button"
                      @click="showConfirmDeleteModal(assessment)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-a-modified-date">
              {{ assessment.updated_at | formatDate }}
            </span>
              <Avatar v-if="assessment.updated_by" :object="assessment.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="assessment.updated_by" qid="view-a-modified-by">
              {{ assessment.updated_by.name }}
            </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- Basic info tab -->
      <b-tab :title="$t('maintenance.assessments.tab.basic_info')" active @click="basicInfoTabClicked">
        <div class="card mt-3">
          <div class="card-body">
            <div class="content-view-body">
              <div class="mb-2">
                <h5 class="h5">
                  {{ $t('maintenance.assessments.create.description_label') }}
                </h5>
                <span v-if="getGuide('assessment_template_description')">
                  <GuideButton :guide="getGuide('assessment_template_description')"></GuideButton>
                </span>
              </div>
              <p v-if="assessment.description"
                 class="text-formatted"
              >
                {{ assessment.description }}
              </p>
              <br>
            </div>
          </div>
        </div>

        <div class="card mt-3" v-if="assessment.type == 'control'">
          <div class="card-body">
            <div class="content-view-body">
              <div class="mb-3">
                <h5 class="h5">
                  {{ $t('maintenance.assessments.configurations_title') }}
                </h5>
              </div>
              <div class="mb-3">
                <h6 class="h6">
                  <span class="float-right" v-if="showAllowForm">
                    <div class="text-right">
                      <b-button class="btn-sm inline-edit-button"
                                variant="secondary"
                                @click="cancelAllowForm"
                                qid="assessment-include-mapping-cancel-button"
                      >
                        {{ $t('processes.legal_basis.create.cancel') }}
                      </b-button>
                      <b-button class="ml-2 mr-0 btn-sm inline-edit-button"
                                variant="success"
                                @click="formAllowSubmit"
                                qid="assessment-include-mapping-submit-button"
                      >
                        {{ $t('processes.legal_basis.create.submit') }}
                      </b-button>
                    </div>
                  </span>
                  <span class="float-right btn btn-sm btn-edit mr-0"
                        @click="showAllowFormFunction"
                        qid="assessment-include-mapping-edit-button"
                        v-if="!showAllowForm"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  {{ $t('maintenance.assessments.include_mapping_title') }}
                </h6>
                <span v-if="getGuide('assessment_template_measures')">
                  <GuideButton :guide="getGuide('assessment_template_measures')"></GuideButton>
                </span>
              </div>
              <div v-if="showAllowForm" class="mw-300 mb-3">
                <multiselect
                    v-model="allowMapping"
                    :options="allowOptions"
                    :multiple="false"
                    :taggable="false"
                    label="text"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('validations.create.status_label')"
                ></multiselect>
              </div>
              <div v-if="!showAllowForm" class="mw-300 mb-3">
                <span v-if="assessment.include_mapping != 1">
                  <font-awesome-icon icon="times-circle" class="icon-danger mr-2"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="assessment.include_mapping == 1">
                  <font-awesome-icon icon="check-circle" class="icon-success mr-2"/>
                  {{ $t('system.yes') }}
                </span>
              </div>
              <div class="mb-3">
                <h6 class="h6">
                  <span class="float-right" v-if="showIndependenceForm">
                    <div class="text-right">
                      <b-button class="btn-sm inline-edit-button"
                                variant="secondary"
                                @click="cancelIndependenceForm"
                                qid="assessment-independence-declaration-cancel-button"
                      >
                        {{ $t('processes.legal_basis.create.cancel') }}
                      </b-button>
                      <b-button class="ml-2 mr-0 btn-sm inline-edit-button"
                                variant="success"
                                @click="formIndependenceSubmit"
                                qid="assessment-independence-declaration-submit-button"
                      >
                        {{ $t('processes.legal_basis.create.submit') }}
                      </b-button>
                    </div>
                  </span>
                  <span class="float-right btn btn-sm btn-edit mr-0"
                        @click="showIndependenceFormFunction"
                        qid="assessment-independence-declaration-edit-button"
                        v-if="!showIndependenceForm"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  {{ $t('maintenance.assessments.require_independence_declaration_title') }}
                </h6>
              </div>
              <div v-if="showIndependenceForm" class="mw-300 mb-3">
                <multiselect
                    v-model="includeIndependence"
                    :options="allowOptions"
                    :multiple="false"
                    :taggable="false"
                    label="text"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('validations.create.status_label')"
                ></multiselect>
              </div>
              <div v-if="!showIndependenceForm" class="mw-300 mb-3">
                <span v-if="assessment.include_independence_declaration != 1">
                  <font-awesome-icon icon="times-circle" class="icon-danger mr-2"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="assessment.include_independence_declaration == 1">
                  <font-awesome-icon icon="check-circle" class="icon-success mr-2"/>
                  {{ $t('system.yes') }}
                </span>
              </div>
              <div class="mb-3">
                <h6 class="h6">
                  <span class="float-right" v-if="showSignOffForm">
                    <div class="text-right">
                      <b-button class="btn-sm inline-edit-button"
                                variant="secondary"
                                @click="cancelSignOffForm"
                                qid="assessment-required-sign-offs-cancel-button"
                      >
                        {{ $t('processes.legal_basis.create.cancel') }}
                      </b-button>
                      <b-button class="ml-2 mr-0 btn-sm inline-edit-button"
                                variant="success"
                                @click="formSignOffSubmit"
                                qid="assessment-required-sign-offs-submit-button"
                      >
                        {{ $t('processes.legal_basis.create.submit') }}
                      </b-button>
                    </div>
                  </span>
                  <span class="float-right btn btn-sm btn-edit mr-0"
                        @click="showSignOffFormFunction"
                        qid="assessment-required-sign-offs-edit-button"
                        v-if="!showSignOffForm"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  {{ $t('system.required_sign_offs') }}
                </h6>
              </div>
              <div v-if="showSignOffForm" class="mw-300 mb-3">
                <NumberStepper v-model="requiredSignOffs" qid="assessment-required-sign-offs"></NumberStepper>
                <small class="form-text text-muted">{{ $t('system.required_sign_offs_description') }}</small>
              </div>
              <div v-if="!showSignOffForm" class="mw-300 mb-3" qid="assessment-required-sign-offs-value">
                {{ assessment.required_sign_offs ? assessment.required_sign_offs : 0 }}
              </div>
              <div class="mb-3">
                <h6 class="h6">
                  <span class="float-right" v-if="showRelationsForm">
                    <div class="text-right">
                      <b-button class="btn-sm inline-edit-button"
                                variant="secondary"
                                @click="cancelRelationsForm"
                                qid="assessment-include-relations-cancel-button"
                      >
                        {{ $t('processes.legal_basis.create.cancel') }}
                      </b-button>
                      <b-button class="ml-2 mr-0 btn-sm inline-edit-button"
                                variant="success"
                                @click="formRelationsSubmit"
                                qid="assessment-include-relations-submit-button"
                      >
                        {{ $t('processes.legal_basis.create.submit') }}
                      </b-button>
                    </div>
                  </span>
                  <span class="float-right btn btn-sm btn-edit mr-0"
                        @click="showRelationsFormFunction"
                        qid="assessment-include-relations-edit-button"
                        v-if="!showRelationsForm"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  {{ $t('projects.create.include_relations') }}
                </h6>
              </div>
              <div v-if="showRelationsForm" class="mw-300 mb-3">
                <multiselect
                    v-model="includeRelations"
                    :options="allowOptions"
                    :multiple="false"
                    :taggable="false"
                    label="text"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('validations.create.status_label')"
                ></multiselect>
              </div>
              <div v-if="!showRelationsForm" class="mw-300 mb-3">
                <span v-if="assessment.include_relations != 1">
                  <font-awesome-icon icon="times-circle" class="icon-danger mr-2"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="assessment.include_relations == 1">
                  <font-awesome-icon icon="check-circle" class="icon-success mr-2"/>
                  {{ $t('system.yes') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-3" v-if="assessment.type == 'control' || assessment.type == 'risk'">
          <div class="card-body">
            <div class="content-view-body">
              <div class="mb-2">
                <h5 class="h5">
                  {{ $t('maintenance.assessments.create.upload_report_label') }}
                </h5>
                <span v-if="getGuide('report_template')">
                  <GuideButton :guide="getGuide('report_template')"></GuideButton>
                </span>
              </div>
              <b-alert v-if="error.length"
                       show
                       variant="danger"
                       qid="create-q-error"
              >
                {{ error }}
              </b-alert>
              <b-form-group>
                <div v-show="showDropActive" class="drop-active">
                  <h3>Drop files to upload</h3>
                </div>
                <div class="form-control auto-height pt-3 pb-3 mt-2">
                  <div class="text-center">
                    <p>
                      Drag and drop or
                      <file-upload
                        ref="uploader-template"
                        v-model="files"
                        :drop="true"
                        input-id="template-file"
                        :extensions="extensions"
                        :accept="accept"
                        :multiple="false"
                        @input="onFileChangeEdit"
                        @dropActive="showDropActiveFunction"
                        class="text-success cursor-pointer"
                      >
                        click here
                      </file-upload>
                      to upload file. The format must be Microsoft Word (.docx). See user guide for input on how to build a template file.
                    </p>

                  </div>

                  <div v-if="assessment.media && assessment.media.length">
                    <p v-for="file in assessment.media" v-if="file.collection_name == 'template'">
                      <span class="float-right text-muted cursor-pointer"
                            @click="openDeleteAttachmentModal(file)"
                            qid="remove-media-item"
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </span>
                      <span class="mr-3 float-right text-muted cursor-pointer"
                            @click="downloadMedia(file)"
                            qid="download-media"
                      >
                        <font-awesome-icon icon="cloud-download-alt" />
                      </span>
                      <a @click="downloadMedia(file)" qid="create-q-media-item">
                        {{ file.file_name }}
                      </a>
                    </p>
                  </div>

                </div>
              </b-form-group>
              <br>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- Scope tab -->
      <b-tab :title="$t('maintenance.assessments.tab.scope')" @click="scopeTabClicked" v-if="assessment && assessment.question && assessment.type != 'bia'">

        <div class="card scope mt-3"  style="display: none">
          <div class="card-header">
            <div class="float-left w-100">
              <span class="h5" qid="assessment-scope-section-title">
                {{ $t('maintenance.assessments.scope_title') }}
              </span>
              <span v-if="!showForm && isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                    class="float-right btn btn-success"
                    qid="assessment-scope-section-edit-button"
                    @click="showFormFunction"
              >
                  <font-awesome-icon icon="pen" /> {{ $t('system.edit') }}
                </span>
            </div>

          </div>
          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <p class="mt-2">
                  {{ $t('maintenance.assessments.questions_label') }}
                </p>
                <br v-if="(assessment.scope == 'process' || assessment.scope == 'activity') && getClient.processingActivitiesModule && getClient.systemModule">
                <p v-if="(assessment.scope == 'process' || assessment.scope == 'activity') && getClient.processingActivitiesModule && getClient.systemModule">
                  {{ $t('maintenance.assessments.system_impact_assessment_label') }}
                </p>
                <br>
              </div>
            </div>
            <div class="col-sm-10">
              <div class="card-body">
                <div v-if="showForm">
                  <b-form-radio-group
                    v-model="scopeForm.question"
                    :options="radioOptions"
                    qid="assessment-scope-section-questions-form-radio"
                  ></b-form-radio-group>
                  <br>

                  <b-form-radio-group
                    v-model="scopeForm.system_impact_assessment"
                    :options="radioOptions"
                    qid="assessment-scope-section-bia-form-radio"
                    class="mt-1"
                    v-if="(assessment.scope == 'process' || assessment.scope == 'activity') && getClient.processingActivitiesModule && getClient.systemModule"
                  ></b-form-radio-group>
                  <br>
                  <div class="text-left">
                    <b-button class="mt-3"
                              variant="secondary"
                              @click="cancelFormFunction"
                              qid="assessment-scope-section-edit-cancel-button"
                    >
                      {{ $t('activities.create.cancel') }}
                    </b-button>
                    <b-button class="mt-3 ml-3"
                              variant="success"
                              @click="formSubmit"
                              qid="assessment-scope-section-edit-submit-button"
                    >
                      {{ $t('activities.create.submit') }}
                    </b-button>
                  </div>
                </div>

                <div v-if="!showForm">
                  <p class="mt-2">
                    <span v-if="assessment && assessment.question">
                      <span class="badge-pill badge-success mr-1">
                        <font-awesome-icon icon="check" size="xs"/>
                      </span>
                      {{ $t('system.yes') }}
                    </span>
                    <span v-else>
                      <span class="badge-pill badge-danger mr-1">
                        <font-awesome-icon icon="times" size="xs"/>
                      </span>
                      {{ $t('system.no') }}
                    </span>
                  </p>

                  <br v-if="assessment.scope == 'process' || assessment.scope == 'activity' && getClient.processingActivitiesModule && getClient.systemModule">
                  <p v-if="assessment.scope == 'process' || assessment.scope == 'activity' && getClient.processingActivitiesModule && getClient.systemModule">
                    <span v-if="assessment && assessment.system_impact_assessment">
                      <span class="badge-pill badge-success mr-1">
                        <font-awesome-icon icon="check" size="xs"/>
                      </span>
                      {{ $t('system.yes') }}
                    </span>
                    <span v-else>
                      <span class="badge-pill badge-danger mr-1">
                        <font-awesome-icon icon="times" size="xs"/>
                      </span>
                      {{ $t('system.no') }}
                    </span>
                  </p>
                  <br>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="showScopeTab">
          <QuestionsTable :object="assessment" v-if="assessment && assessment.question && (assessment.type == 'control' || assessment.type == 'risk')"></QuestionsTable>
          <QuestionsOldTable :object="assessment" v-if="assessment && assessment.question && assessment.type != 'control' && assessment.type != 'risk'"></QuestionsOldTable>
        </div>

      </b-tab>


      <!-- History tab -->
      <b-tab :title="$t('activities.tab.history')" class="mt-3" @click="historyTabClicked">
        <div v-if="showHistoryTab">
          <AssessmentHistory :object="assessment"></AssessmentHistory>
        </div>
      </b-tab>

    </b-tabs>


    <!-- Edit assessment question modal template -->
    <b-modal ref="edit-assessment" @hide="hideEditAModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditAModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-a-title">
            {{ $t('maintenance.assessments.update.title') }}
          </h5>
          <div class="row mt-3 pt-4 pb-1 pl-5 pr-5">
            <div class="col-sm-12"
                 v-if="getGuide('update_assessment_template')"
            >
              <b-form-group>
                <div class="">
                  <label qid="create-p-users-label">
                    <GuideButton :guide="getGuide('update_assessment_template')"></GuideButton>
                  </label>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-a-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editAFormSubmit" qid="edit-a-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-a-name-label">
              {{ $t('maintenance.assessments.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-a-form-name"
              type="text"
              v-model="form.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-a-description-label">
              {{ $t('maintenance.assessments.create.description_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-textarea
              qid="edit-a-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <!-- <b-form-group>
            <label qid="create-a-type-label">
              {{ $t('projects.create.type_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="type"
                :options="types"
                :placeholder="$t('projects.create.type_placeholder')"
                label="name"
                :allow-empty="false"
                required
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-a-form-type"
            ></multiselect>
          </b-form-group> -->
          <b-form-group v-if="type.value == 'bia'">
            <label qid="create-a-scope-label">
              {{ $t('projects.create.scope_label') }}
            </label>
            <multiselect
                v-model="scope"
                :options="scopes"
                :placeholder="$t('projects.create.scope_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-a-form-scope"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditAModal"
                            qid="edit-a-cancel-button"
                  >
                    {{ $t('maintenance.assessments.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="edit-a-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.assessments.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete retention rule confirm modal template -->
    <b-modal ref="delete-assessment" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="delete-a-title">
            {{ $t('maintenance.assessments.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.assessments.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.assessments.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideConfirmDeleteModal"
                            qid="delete-a-cancel-button"
                  >
                    {{ $t('maintenance.assessments.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteA(itemToDelete)"
                            class="ml-3"
                            variant="danger"
                            qid="delete-a-submit-button"
                            v-if="isGranted([permissions.ASSESSMENT_DELETE, permissions.ASSESSMENT_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                  >
                    {{ $t('maintenance.assessments.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import QuestionsTable from '@/views/Assessments/QuestionsTable.vue';
import QuestionsOldTable from '@/views/Assessments/QuestionsOldTable.vue';
import AssessmentHistory from '@/views/Assessments/AssessmentHistory.vue';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideButton from '@/components/guide/GuideButton.vue';
import NumberStepper from '@/components/NumberStepper.vue';

export default {
  name: 'AssessmentView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.assessments.title'),
          to: '/maintenance/assessment-templates'
        }
      ],

      accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      extensions: 'docx',

      files: [],
      selectedFile: {},
      uploader: false,
      showDropActive: false,
      showDeleteAttachmentModal: false,

      assessment: {},
      showInput: false,
      itemToDelete: {},
      form: {
        name: '',
        description: '',
        client:'',
      },
      scopeForm: {
        question: '',
        business_risk_assessment: '',
        privacy_risk_assessment: '',
        system_impact_assessment: ''
      },
      error: '',
      buttonDisabled: false,
      myGuides: [],
      showFullGuideDescription: false,
      wpGuide: {},
      showForm: false,

      radioOptions: [
        {text: this.$t('system.yes'), value: 1},
        {text: this.$t('system.no'), value: 0}
      ],

      // Pagination
      perPageOptions: [
        { name: '10', value: '10' },
        { name: '20', value: '20' },
        { name: '50', value: '50' },
        { name: '100', value: '100' }
      ],
      types: [
        { name: this.$t('maintenance.assessments.type.control'), value: 'control' },
        { name: this.$t('maintenance.assessments.type.risk'), value: 'risk' },
        { name: this.$t('maintenance.assessments.type.bia'), value: 'bia' }
      ],
      scopes: [
        { name: this.$t('projects.scope.process'), value: 'process' },
        { name: this.$t('projects.scope.activity'), value: 'activity' },
        { name: this.$t('projects.scope.system'), value: 'system' },
        { name: this.$t('projects.scope.third_party'), value: 'third_party' }
      ],
      risk_scopes: [
        { name: this.$t('projects.scope.process'), value: 'process' },
        { name: this.$t('projects.scope.activity'), value: 'activity' },
        { name: this.$t('projects.scope.third_party'), value: 'third_party' },
      ],
      bia_scopes: [
        { name: this.$t('projects.scope.process'), value: 'process' },
        { name: this.$t('projects.scope.activity'), value: 'activity' }
      ],
      allowOptions: [
        {text: this.$t('system.no'), value: 0},
        {text: this.$t('system.yes'), value: 1},
      ],
      allowMapping: [],
      includeRelations: [],
      includeIndependence: [],
      include_relations: '',
      showAllowForm: false,
      showRelationsForm: false,
      showIndependenceForm: false,
      showSignOffForm: false,
      requiredSignOffs: 0,
      type: [],
      scope: [],

      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,
      selectedSort: '',
      selectedDirection: '',

      showHistoryTab: false,
      showScopeTab: false,
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getWordpressLink() {
      return this.$store.state.wordpressLink
    },
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      } else {
        this.loadContent();
      }
    }
  },
  components: {
    Avatar,
    QuestionsTable,
    QuestionsOldTable,
    AssessmentHistory,
    ConfirmRemoveAttachment,
    GuideButton,
    NumberStepper
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/assessment-templates')
    },
    showDropActiveFunction(value) {
      this.showDropActive = value;
    },
    showAllowFormFunction() {
      let self = this;

      this.allowMapping = []
      if (this.assessment.include_mapping) {
        this.allowMapping = _.find(this.allowOptions, function(item) {
          return item.value === self.assessment.include_mapping;
        });
      } else {
        this.allowMapping = this.allowOptions[0]
      }

      this.showAllowForm = true;
    },
    showRelationsFormFunction() {
      let self = this;

      this.includeRelations = []
      if (this.assessment.include_relations) {
        this.includeRelations = _.find(this.allowOptions, function(item) {
          return item.value === self.assessment.include_relations;
        });
      } else {
        this.includeRelations = this.allowOptions[0]
      }

      this.showRelationsForm = true;
    },
    showIndependenceFormFunction() {
      this.includeIndependence = this.assessment.include_independence_declaration == 1 ? this.allowOptions[1] : this.allowOptions[0]
      this.showIndependenceForm = true;
    },
    showSignOffFormFunction() {
      this.requiredSignOffs = this.assessment.required_sign_offs ? this.assessment.required_sign_offs : 0;
      this.showSignOffForm = true;
    },
    cancelSignOffForm() {
      this.showSignOffForm = false;
    },
    formSignOffSubmit() {
      let self = this;

      piincHttp.put('assessments/' + this.$route.params.slug, {
        required_sign_offs: this.requiredSignOffs,
      }).then(function() {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.showSignOffForm = false;
        self.$toastr('success', self.$t('maintenance.assessments.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    cancelIndependenceForm() {
      this.includeIndependence = []
      this.showIndependenceForm = false;
    },
    formIndependenceSubmit() {
      let self = this;

      piincHttp.put('assessments/' + this.$route.params.slug, {
        include_independence_declaration: this.includeIndependence && this.includeIndependence.value ? this.includeIndependence.value : null,
      }).then(function() {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.showIndependenceForm = false;
        self.$toastr('success', self.$t('maintenance.assessments.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    cancelAllowForm() {
      this.allowMapping = []
      this.showAllowForm = false;
    },
    cancelRelationsForm() {
      this.includeRelations = []
      this.showRelationsForm = false;
    },
    formAllowSubmit() {
      let self = this;

      piincHttp.put('assessments/' + this.$route.params.slug, {
        include_mapping: this.allowMapping && this.allowMapping.value ? this.allowMapping.value : null,
      }).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.showAllowForm = false;
        self.$toastr('success', self.$t('maintenance.assessments.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    formRelationsSubmit() {
      let self = this;

      piincHttp.put('assessments/' + this.$route.params.slug, {
        include_relations: this.includeRelations && this.includeRelations.value ? this.includeRelations.value : null,
      }).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.showRelationsForm = false;
        self.$toastr('success', self.$t('maintenance.assessments.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    onFileChangeEdit(files) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "template");
      formData.append("model_type", this.assessment.who_am_i);
      formData.append("model_id", this.assessment.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.files = []
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'))
          self.error = ''
          self.breadcrumbItems.pop();
          self.loadContent()
          // reset the model array
          self.files = []
        }, function(error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0]
          }
        })
      }
    },
    openDeleteAttachmentModal(object) {
      this.selectedFile = object
      this.showDeleteAttachmentModal = true
    },
    closeDeleteAttachmentModal () {
      this.selectedFile = {}
      this.showDeleteAttachmentModal = false;
      this.breadcrumbItems.pop();
      this.loadContent()
    },
    downloadMedia(object){
      piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove()
        window.URL.revokeObjectURL(url);
      }, function() {});
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    loadGuidesWP(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
            self.wpGuide = response.data
          }, function() {});
        }
      }, function() {});
    },
    formDescriptionSubmit() {
      let self = this;
      piincHttp.put('assessments/' + this.$route.params.slug, {
        description: this.assessmentEditDescription
      }).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.showDescriptionInput = false;
        self.$toastr('success', self.$t('maintenance.assessments.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    showFormFunction() {
      let self = this;
      this.scopeForm.question = this.assessment.question == null ? 0 : this.assessment.question
      this.scopeForm.business_risk_assessment = this.assessment.business_risk_assessment == null ? 0 : this.assessment.business_risk_assessment
      this.scopeForm.privacy_risk_assessment = this.assessment.privacy_risk_assessment == null ? 0 : this.assessment.privacy_risk_assessment
      this.scopeForm.system_impact_assessment = this.assessment.system_impact_assessment == null ? 0 : this.assessment.system_impact_assessment
      this.showForm = true;
    },
    cancelFormFunction() {
      this.showForm = false;
    },
    formSubmit() {
      let self = this;
      piincHttp.put('assessments/' + this.$route.params.slug, this.scopeForm).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.buttonDisabled = false;
        self.cancelFormFunction();
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.scopeForm.error = error.data.message;
        }
      })
    },
    loadContent() {
      let self = this;
      piincHttp.get('assessments/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug,
        }
      }).then(function(response) {
        self.assessment = response.data;
        // Push content name in breadcrumb array
        self.breadcrumbItems.push({text: self.assessment.name, active: true});
      }, function() {});
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-assessment'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-assessment'].hide()
    },
    confirmDeleteA(object) {
      let self = this;
      piincHttp.delete('assessments/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.assessments.delete.success'))
      }, function() {});
    },
    showEditAModal(object) {

      this.loadGuidesWP('update_assessment_template');

      let self = this;

      if (object.type == 'risk') {
        this.scopes = this.risk_scopes;
      } else {
        if (object.type == 'bia') {
          this.scopes = this.bia_scopes;
        } else {
          this.scopes = [];
        }
      }

      this.type = []
      if (object.type) {
        this.type = _.find(this.types, function(item) {
          return item.value === object.type;
        });
      }

      this.scope = []
      if (object.scope) {
        this.scope = _.find(this.scopes, function(item) {
          return item.value === object.scope;
        });
      }

      this.form.slug = object.slug;
      this.form.name = object.name;
      this.form.description = object.description;

      this.$refs['edit-assessment'].show()
    },
    hideEditAModal() {
      this.timeLimitInput = ''
      this.$refs['edit-assessment'].hide()
    },
    editAFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.form.client = this.getClient.slug;
      this.form.type = this.type ? this.type.value : '';
      this.form.scope = this.scope ? this.scope.value : '';

      if (this.type.value == 'control' || (this.type.value == 'risk' && this.scope && this.scope.value) || (this.type.value == 'bia' && this.scope && this.scope.value)) {
        piincHttp.put('assessments/' + this.form.slug, this.form).then(function(response) {
          self.hideEditAModal();
          self.buttonDisabled = false;
          // If slug is not changed, just reload content
          if (response.data.slug === self.assessment.slug) {
            // Remove last item in breadcrumbs, because it will be added again on load content
            self.breadcrumbItems.pop();
            self.loadContent();
          } else {
            // If slug changed, reload state with new param
            self.$router.push({ name: 'maintenance.assessments.view', params: { slug: response.data.slug }})
          }
          self.$toastr('success', self.$t('maintenance.assessments.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (!this.type || (this.type && !this.type.value)) {
          this.error += ' ' + this.$t('maintenance.assessments.create.type_error_message')
        }
        if (!this.scope || (this.scope && !this.scope.value)) {
          this.error += this.$t('maintenance.assessments.create.scope_error_message')
        }
      }
    },
    basicInfoTabClicked() {
      this.showScopeTab = false;
      this.showHistoryTab = false;
    },
    scopeTabClicked() {
      this.showScopeTab = true;
      this.showHistoryTab = false;
    },
    historyTabClicked() {
      this.showHistoryTab = true;
      this.showScopeTab = false;
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
    }
    this.loadGuides('assessment_template');
    this.loadGuides('report_template');
    this.loadGuides('assessment_template_measures');
    this.loadGuides('assessment_template_description');
  }
}
</script>
